<template>
  <div class="DataInfo">
    <Banner></Banner>
    <!-- <Crumbs></Crumbs> -->
    <div class="DataInfo_content" v-if="terminal == 'pc'">
      <div class="DataInfo_content_top">
        <LeftContent></LeftContent>
        <RightContent></RightContent>
      </div>
    </div>
    <div v-else>
      <MobileDataContent></MobileDataContent>
      <!-- <LeftContent></LeftContent>
        <RightContent></RightContent> -->
    </div>

    <BottomContent :otherdatalist="otherdatalist"></BottomContent>
  </div>
</template>

<script>
import bus from "@/bus";
import { mapMixin } from "@/util/mixin";
import { dataList, datainfo, otherData } from "@/axios/datashare.js";
export default {
  name: "DataInfo",
  mixins: [mapMixin],
  data() {
    return {
      info: null,
      dataId: null,
      currentPage: 1,
      pageSizes: 10,
      list: null,
      tableData: null,
      otherdatalist: [],
    };
  },
  destroyed() {
    bus.$off("emitGetDataList");
  },
  components: {
    Banner: () => import("../components/DataInfo/Banner/Banner.vue"),
    // Crumbs: () => import("../components/DataInfo/Crumbs/Crumbs.vue"),
    // Description: () =>
    //   import("../components/DataInfo/Description/Description.vue"),
    // DataContent: () =>
    //   import("../components/DataInfo/DataContent/DataContent.vue"),
    LeftContent: () =>
      import("../components/DataInfo/DataContent/LeftContent.vue"),
    RightContent: () =>
      import("../components/DataInfo/DataContent/RightContent.vue"),
    BottomContent: () =>
      import("../components/DataInfo/DataContent/BottomContent.vue"),
    MobileDataContent: () =>
      import("../components/DataInfo/DataContent/MobileDataContent.vue"),
  },
  mounted() {
    this.dataId = this.$route.query.dataId;
    this.getDatainfo();
    bus.$on("emitGetDataList", (param) => {
      this.currentPage = param.currentPage;
      this.pageSizes = param.pageSizes;
      this.getDataList();
    });
  },
  watch: {
    $route: {
      // $route可以用引号，也可以不用引号
      handler(to, from) {
        this.dataId = this.$route.query.dataId;
        this.getDatainfo();
        this.getDataList();
      },
      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  methods: {
    // 其他数据集
    async getOtherData(dataType) {
      var res = await otherData(dataType);
      this.otherdatalist = res.data.data;
    },
    // 获取数据详情
    async getDatainfo() {
      var res = await datainfo(this.dataId);
      this.info = res.data.data;
      this.setDataInfo(this.info);
      this.getOtherData(this.info.dataType);
    },
    async getDataList() {
      console.log(this.dataId);
      var param = {
        id: this.dataId,
        currentPage: this.currentPage,
        pageSizes: this.pageSizes,
      };
      try {
        var res = await dataList(param);
      } catch (error) {
        this.setDataListTable();
      }
      var data = res.data.data;
      if (!data) {
        this.setDataListTable();
        // return;
      }
      var cnNames = data.cnNames.split(",");
      var enNames = data.enNames.split(",");
      var displayNames = data.displayNames.split(",");
      var name = [];

      for (var i = 0; i < cnNames.length; i++) {
        name.push({
          cnNames: cnNames[i],
          enNames: enNames[i],
          displayNames: displayNames[i],
        });
      }

      this.tableData = data.pageVo;
      var obj = {
        tableData: this.tableData,
        hearder: name,
        total: "",
        currentPage: "",
      };
      this.setDataListTable(obj);
    },
  },
};
</script>

<style lang="scss" scoped>
.DataInfo {
  background: #f5f6f6;

  .DataInfo_content {
    // position: relative;
    // top: -60px;
    width: 1200px;
    margin: auto;
    border-radius: 10px;

    .DataInfo_content_top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: -72px;
      margin-bottom: 48px;
      // background: #fff;
      // border-radius: 4px;
    }
  }
}
</style>